export const ACTIONTYPES = {
    //LOGIN
    SET_LOGIN_USER: "SET_LOGIN_USER",
    LOGIN_USER: "LOGIN_USER",
    LOGIN_USER_SUCCESS: "LOGIN_USER_SUCCESS",
    LOGIN_USER_FAILURE: "LOGIN_USER_FAILURE",
    LOGOUT_USER: "LOGOUT_USER",
}